import type { CarrierServiceMethodInfo } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const serviceMethods = {
  /**
   * Origin-resolved service method definition: carrier-service applies inheritance, merges the
   * override matching `originCountry`, and strips `originCountryOverrides` from the response.
   *
   * `originCountry` is omitted when blank rather than sent empty. A blank value is not an error
   * upstream — the request answers 200 with an unresolved definition, which is indistinguishable
   * from a resolved one at the call site.
   */
  getResolved: {
    queryKey: 'carrier-service/service-methods/resolved',
    configurationType: 'cached' as const,
    fn: async (serviceMethodId: string, originCountry: string) => {
      const { data } = await GatewayAxiosClient.get<CarrierServiceMethodInfo>(
        `/carrier-proxy/api/v2/carriers/serviceMethods/${serviceMethodId}/resolved`,
        originCountry ? { params: { originCountry } } : undefined,
      );

      return data;
    },
  },
};
